/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ILoyaltySignUpViewProps } from '@msdyn365-commerce-modules/account-management/src/modules/loyalty-sign-up/./loyalty-sign-up';
import { ILoyaltySignUpProps } from '../definition-extensions/loyalty-sign-up.ext.props.autogenerated';

const LoyaltySignUpView: React.FC<ILoyaltySignUpViewProps & ILoyaltySignUpProps<{}>> = props => {
    const {
        LoyaltySignUp,
        heading,
        memberHeading,
        signInLink,
        signUpText,
        signUpButton,
        detailsLink,
        // termsLink, Not needed
        loading,
        infoMessageBar
    } = props;

    if (loading) {
        props.context.telemetry.error('LoyaltySignUp data is empty, module wont render');
        return null;
    }

    // const hostname = props?.context?.request?.url?.requestUrl?.hostname || '';

    if (typeof window !== 'undefined') {
        const loyalty_join_toggle_btn = document.getElementsByClassName("ms-loyalty-terms__toggle")[0];
        loyalty_join_toggle_btn?.addEventListener("click", () => {
            const loyalty_join_btn = document.getElementsByClassName("ms-loyalty-terms__submit")[0];
            loyalty_join_btn.addEventListener("click", () => {
                loyalty_join_btn.innerHTML = '<div class=\'loading\'/>';
            })
        });
    }

    /*
    [signInLink = true, loyalty_join_flag = false] guest (no loyalty join) -> standard sign in
    [signInLink = true, loyalty_join_flag = true] guest (loyalty join) -> "thanks" instead of sign in
    [signInLink = false] logged in -> hidden module content
    */
    const loyalty_join_flag = props.context.request.query?.hasJoined;
    // signInLink is null (thus false) when the user is logged in
    return (signInLink && (loyalty_join_flag ? (
        <div className="loyalty-join">
            {props.resources.joinedLoyaltyThankYouHeader && (<h1 className='loyalty-join-header'>{props.resources.joinedLoyaltyThankYouHeader}</h1>)}
            {props.resources.joinedLoyaltyParagraphContent && (<div className='loyalty-join-paragraph'><p>{props.resources.joinedLoyaltyParagraphContent}</p></div>)}
            {/* {props.resources.loyaltyBalanceCheckURL && props.resources.joinedLoyaltyBalanceCheckLinkText && (<a className='loyalty-join-balance-check-link' href={`https://${hostname}${props.resources.loyaltyBalanceCheckURL}`}>{props.resources.joinedLoyaltyBalanceCheckLinkText}</a>)} */}
        </div>
    ) : (
        <Module {...LoyaltySignUp}>
            {infoMessageBar}
            {memberHeading}
            {heading}
            {detailsLink}
            {signUpText}
            {/* {termsLink} Not needed */}
            {signUpButton}
            {signInLink}
        </Module>
    )
    )
    );
};

export default LoyaltySignUpView;
